// src/components/Hero.js
import React, { useState } from 'react';
import { getImageAssetUrl } from '../utils/imageAssets';

const Hero = ({ onPaymentClick }) => {
  const [usePngFallback, setUsePngFallback] = useState(false);

  return (
    <section className="container hero-section">
      <div className="hero-layout">
        <div className="hero-content">
          <p className="hero-topline">
            Выкуп оригинальных товаров <br /> и организация доставки из США и Европы
          </p>

          <h1 className="hero-title">
            SHOPTOP
            <br />
            BRANDS
          </h1>

          <h2 className="hero-subtitle">
            Ваш байерский сервис
            <br />
            для выгодных покупок
            <br />
            за рубежом
          </h2>

          
        </div>

        <div className="hero-image-wrap">
          <picture>
            {!usePngFallback && (
              <source
                media="(max-width: 767px)"
                type="image/webp"
                srcSet={getImageAssetUrl('/images/hero/hero-mobile.webp')}
              />
            )}
            <source
              media="(max-width: 767px)"
              srcSet={getImageAssetUrl('/images/hero/hero-mobile.png')}
            />
            {!usePngFallback && (
              <source
                type="image/webp"
                srcSet={getImageAssetUrl('/images/hero/hero-desktop.webp')}
              />
            )}
            <img
              className="hero-image"
              src={getImageAssetUrl('/images/hero/hero-desktop.png')}
              alt="SHOPTOP BRANDS hero"
              width="1122"
              height="927"
              decoding="async"
              fetchPriority="high"
              onError={() => {
                if (!usePngFallback) setUsePngFallback(true);
              }}
            />
          </picture>
        </div>
      </div>

      <div className="buttons-hero">
        <a
          className="hero-btn hero-btn-primary"
          href="https://t.me/kupivamerike_bot?start=2490149489"
        >
          <span>Оформить заказ</span>
        </a>

        <button
          className="hero-btn hero-btn-secondary"
          id="open-payment-form"
          onClick={onPaymentClick}
          type="button"
        >
          <span>Оплатить</span>
        </button>

        <a
          className="hero-btn hero-btn-outline"
          href="https://t.me/kupivamerike_bot?start=2490149489"
        >
          <span>Сообщить об оплате</span>
        </a>
      </div>

      <div className="hero-links-wrap">
        <p className="hero-links-label">Следите за анонсами на наших площадках</p>

        <div className="hero-links">
          <a href="https://t.me/shoptop_brands" target="_blank" rel="noreferrer">
            Наш Telegram
          </a>
          <a href="https://max.ru/id540860074774_biz" target="_blank" rel="noreferrer">
            Наш MAX
          </a>
          <a href="https://chat.whatsapp.com/CwruG0W5vuy2uiJ7vfvlkV" target="_blank" rel="noreferrer">
            Наш WhatsApp
          </a>
          <a href="https://forum.sibmama.ru/viewtopic.php?t=788004" target="_blank" rel="noreferrer">
            Наша тема на Сибмаме
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
